import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon, Slider, Switch, Button,
} from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import '../../assets/css/App.css';

import img from "../../assets/images/Fig3.jpg";
import Header1 from '../public';

const { SubMenu } = Menu;
const {
    Header, Content, Footer, Sider,
} = Layout;

class HccCalCalculation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue1: 0,
            inputValue2: 'No',
            inputValue2ture:0,

            inputValue3: 'Absent',
            inputValue3ture:0,

            inputValue4: 0,
            initcalFlag:false,
            calFlag:false,
            TTP1year3:'',
            TTP6month3:'',


            inputValue14: 0,

            inputValue24: 'No',
            inputValue24ture:0,

            inputValue34: 'Absent',
            inputValue34ture:0,

            inputValue44: -1,
            calFlag4:false,
            initcalFlag4:false,
            TTP1year4:'',
            TTP6month4:'',
        }
    }
    onChange1 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        this.setState({
            inputValue1: value,
            calFlag: false,
        });
    }
    onChange2 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        if(value==0)
        {
            this.setState({
                inputValue2ture: value,
                inputValue2:'No',
                calFlag: false,
            });
        }
        else  if(value==1)
        {
            this.setState({
                inputValue2ture: value,
                inputValue2:'Solitary intrahepatic metastasis',
                calFlag: false,
            });
        }
        else  if(value==2)
        {
            this.setState({
                inputValue2ture: value,
                inputValue2:'Multiple intrahepatic metastasis',
                calFlag: false,
            });
        }
        else  if(value==3)
        {
            this.setState({
                inputValue2ture: value,
                inputValue2:'Extrahepatic metastasis',
                calFlag: false,
            });
        }

    }
    onChange3 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        if(value==0)
        {
        this.setState({
            inputValue3ture:value,
            inputValue3: 'Absent',
            calFlag: false,
        });
        }
        else
        {
        this.setState({
            inputValue3ture:value,
            inputValue3: 'Present',
            calFlag: false,
        });
        }
    }
    onChange4 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        this.setState({
            inputValue4: value,
            calFlag: false,
        });
    }
    onClick= (value) => {
        var score=this.state.inputValue1*0.5+this.state.inputValue2ture*21+(1-this.state.inputValue3ture)*22;
        this.setState({
            calFlag: true,
            initcalFlag:true,
        });
        if(score<21)
        this.state.TTP6month3 ='>80%'
    else if((score>=21)&&(score<42))
        this.state.TTP6month3 ='70%~80%'
    else if((score>=42)&&(score<58))
        this.state.TTP6month3 ='60%~70%'
    else if((score>=58)&&(score<72))
        this.state.TTP6month3 ='50%~60%'
    else if((score>=72)&&(score<84))
        this.state.TTP6month3 ='40%~50%'
    else if((score>=84)&&(score<96))
        this.state.TTP6month3 ='30%~40%'
    else if((score>=96)&&(score<109))
        this.state.TTP6month3 ='20%~30%'
    else if((score>=109)&&(score<124))
        this.state.TTP6month3 ='10%~20%'
    else
        this.state.TTP6month3 ='<10%'


    if(score<9)
        this.state.TTP1year3 ='>70%'
    else if((score>=9)&&(score<22))
        this.state.TTP1year3 ='60%~70%'
    else if((score>=22)&&(score<40))
        this.state.TTP1year3 ='50%~60%'
    else if((score>=40)&&(score<51))
        this.state.TTP1year3 ='40%~50%'
    else if((score>=51)&&(score<64))
        this.state.TTP1year3 ='30%~40%'
    else if((score>=64)&&(score<77))
        this.state.TTP1year3 ='20%~30%'
    else if((score>=77)&&(score<93))
        this.state.TTP1year3 ='10%~20%'
    else
        this.state.TTP1year3 ='<10%'
    }



    onChange14 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        this.setState({
            inputValue14: value,
            calFlag4: false,
        });
    }
    onChange24 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        if(value==0)
        {
            this.setState({
                inputValue24:'No',
                inputValue24ture: value,
                calFlag4: false,
            });
        }
        else if(value==1)
        {
            this.setState({
                inputValue24:'Solitary intrahepatic metastasis',
                inputValue24ture: value,
                calFlag4: false,
            });
        }
        else if(value==2)
        {
            this.setState({
                inputValue24:'Multiple intrahepatic metastasis',
                inputValue24ture: value,
                calFlag4: false,
            });
        }
        else if(value==3)
        {
            this.setState({
                inputValue24:'Extrahepatic metastasis',
                inputValue24ture: value,
                calFlag4: false,
            });
        }

    }
    onChange34 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        if(value==0)
        {        
            this.setState({
            inputValue34:'Absent',
            inputValue34ture: value,
            calFlag4: false,
        });
    }
        else{
            this.setState({
                inputValue34:'Present',
                inputValue34ture: value,
                calFlag4: false,
            });
        }

    }
    onChange44 = (value) => {
        if (Number.isNaN(value)) {
            return;
        }
        this.setState({
            inputValue44: value,
            calFlag4: false,
        });
    }
    onClick4= (value) => {
        var score1=this.state.inputValue14*0.5+this.state.inputValue24ture*20+(1-this.state.inputValue34ture)*23+ Math.abs(this.state.inputValue44)*43;
        this.setState({
            calFlag4: true,
            initcalFlag4:true,
        });
        
        if(score1<32)
            this.state.TTP6month4 ='>80%'
        else if((score1>=32)&&(score1<52))
            this.state.TTP6month4 ='70%~80%'
        else if((score1>=52)&&(score1<67))
            this.state.TTP6month4 ='60%~70%'
        else if((score1>=67)&&(score1<79))
            this.state.TTP6month4 ='50%~60%'
        else if((score1>=79)&&(score1<90))
            this.state.TTP6month4 ='40%~50%'
        else if((score1>=90)&&(score1<102))
            this.state.TTP6month4 ='30%~40%'
        else if((score1>=102)&&(score1<114))
            this.state.TTP6month4 ='20%~30%'
        else if((score1>=114)&&(score1<129))
            this.state.TTP6month4 ='10%~20%'
        else
            this.state.TTP6month4 ='<10%'


        if(score1<21)
            this.state.TTP1year4 ='>70%'
        else if((score1>=21)&&(score1<35))
            this.state.TTP1year4 ='60%~70%'
        else if((score1>=35)&&(score1<49))
            this.state.TTP1year4 ='50%~60%'
        else if((score1>=49)&&(score1<59))
            this.state.TTP1year4 ='40%~50%'
        else if((score1>=59)&&(score1<70))
            this.state.TTP1year4 ='30%~40%'
        else if((score1>=70)&&(score1<82))
            this.state.TTP1year4 ='20%~30%'
        else if((score1>=82)&&(score1<98))
            this.state.TTP1year4 ='10%~20%'
        else
            this.state.TTP1year4 ='<10%'

    }

    render() {
        const { inputValue } = this.state;

        //三变量模型的显示运算
        let onShow, onShow4;
        if((this.state.calFlag)&&(this.state.initcalFlag))
        {
            onShow=(
                <div className="onShowNomo">
                <img src={require('../../assets/images/Fig3.jpg')} alt="" style={{ width:"100%",paddingRight:20}} />
                <br></br>
                <txt style={{fontSize:22}}>6-Month predicted time to progression: {this.state.TTP6month3}</txt>
                <br></br>
                <txt style={{fontSize:22}}>1-Year predicted time to progression: {this.state.TTP1year3}</txt>
                </div>
            )
            
        }
        else if(this.state.initcalFlag){
            onShow=(
                <div className="onShowNomo" style={{opacity:0.2}}>
                <img src={require('../../assets/images/Fig3.jpg')} alt="" style={{ width:"100%",paddingRight:20}} />
                <br></br>
                <txt style={{fontSize:22}}>6-Month predicted time to progression: {this.state.TTP6month3}</txt>
                <br></br>
                <txt style={{fontSize:22}}>1-Year predicted time to progression: {this.state.TTP1year3}</txt>
                </div>
            )
        }

        //四变量模型的显示运算
        
        if((this.state.calFlag4)&&(this.state.initcalFlag4))
        {
            onShow4=(
                <div className="onShowNomo">
                <img src={require('../../assets/images/Fig4.jpg')} alt="" style={{ width:"100%",paddingRight:20 }} />
                <br></br>
                <txt style={{fontSize:22}}>6-Month predicted time to progression: {this.state.TTP6month4}</txt>
                <br></br>
                <txt style={{fontSize:22}}>1-Year predicted time to progression: {this.state.TTP1year4}</txt>
                </div>
            )
            
        }
        else if(this.state.initcalFlag4){
            onShow4=(
                <div className="onShowNomo" style={{opacity:0.2}}>
                <img src={require('../../assets/images/Fig4.jpg')} alt="" style={{ width:"100%",paddingRight:20}} />
                <br></br>
                <txt style={{fontSize:22}}>6-Month predicted time to progression: {this.state.TTP6month4}</txt>
                <br></br>
                <txt style={{fontSize:22}}>1-Year predicted time to progression: {this.state.TTP6month4}</txt>
                </div>
            )
        }

        return (
            <div>
                <Header1></Header1>
                <Content style={{ padding: '0 50px' }}>

                    <Layout style={{ background: '#fff' }}>
                        <Sider width={200} style={{ background: '#fff' }}>
                            <Menu
                                mode="inline"
                                defaultSelectedKeys={['6']}
                                defaultOpenKeys={['sub4']}
                                style={{ height: '100%' }}
                            >
                                <SubMenu key="sub3" title={<span><Icon type="user" />Lipiodol</span>}>
                                    <Menu.Item key="1"><Link to="/hcc-ld-introduction">Introduction</Link></Menu.Item>
                                    <Menu.Item key="2"><Link to="/hcc-ld-evaluation">Evaluation</Link></Menu.Item>
                                </SubMenu>
                                <SubMenu key="sub4" title={<span><Icon type="user" />Prediction</span>}>
                                    <Menu.Item key="5"><Link to="/hcc-cal-introduction">Introduction</Link></Menu.Item>
                                    <Menu.Item key="6"><Link to="/hcc-cal-calculation">Calculation</Link></Menu.Item>
                                </SubMenu>
                            </Menu>
                        </Sider>


                        <div style={{width:500,marginLeft: 50, background: '#dcefef' }}>
                        <div style={{width:500,background: '#dcefef' }}>
                            {/*三变量模型 */}
                                <div style={{ paddingLeft: 50, height: 800, background: '#dcefef' }}>
                                    <div className="txt">
                                        {/*第一个变量*/}
                                        <txt style={{fontSize:22}}>Size of the primary tumor</txt>
                                        <Slider style={{ background: '#fff' }} onChange={this.onChange1} max={200} defaultValue={0} />
                                        <txt style={{fontSize:22}} >{this.state.inputValue1} mm</txt>
                                    </div>
                                    <div className="txt">
                                        {/*第二个变量*/}
                                        <txt style={{fontSize:22}}>Intrahepatic/extrahepatic metastasis</txt>
                                        <Slider style={{ background: '#fff' }} onChange={this.onChange2} max={3} defaultValue={0} />
                                        <txt  style={{fontSize:22}}>status: {this.state.inputValue2}</txt>
                                    </div>
                                    <div className="txt">
                                        {/*第三个变量*/}
                                        <txt style={{fontSize:22}}>Tumor capsule</txt>
                                        <Slider style={{ background: '#fff' }} onChange={this.onChange3} max={1} defaultValue={0} />
                                        <txt style={{fontSize:22}}>status: {this.state.inputValue3}</txt>
                                    </div>
                                    <Button type="primary" shape="round" size="large" style={{ marginLeft: 150, marginTop: 60, background: 'rgb(147, 197, 163)' }} onClick={this.onClick}>Calculate</Button>
                                </div>
                        </div>
 
    

                        <div style={{width:500,background: '#dcefef' }}>
                            {/*四变量模型 */}
                                <div style={{ paddingLeft: 50, height: 800, background: '#dcefef' }}>
                                    <div className="txt">
                                        {/*第一个变量*/}
                                        <txt style={{fontSize:22}}>Size of the primary tumor</txt>
                                        <Slider style={{ background: '#fff' }} onChange={this.onChange14} max={200} defaultValue={0} />
                                        <txt style={{fontSize:22}} >{this.state.inputValue14} mm</txt>
                                    </div>
                                    <div className="txt">
                                        {/*第二个变量*/}
                                        <txt style={{fontSize:22}}>Intrahepatic/extrahepatic metastasis</txt>
                                        <Slider style={{ background: '#fff' }} onChange={this.onChange24} max={3} defaultValue={0} />
                                        <txt  style={{fontSize:22}}>status: {this.state.inputValue24}</txt>
                                    </div>
                                    <div className="txt">
                                        {/*第三个变量*/}
                                        <txt style={{fontSize:22}}>Tumor capsule</txt>
                                        <Slider style={{ background: '#fff' }} onChange={this.onChange34} max={1} defaultValue={0} />
                                        <txt style={{fontSize:22}}>status: {this.state.inputValue34}</txt>
                                    </div>
                                    <div className="txt">
                                        {/*第四个变量*/}
                                        <txt style={{fontSize:22}}>LD score</txt>
                                        <Slider style={{ background: '#fff' }} onChange={this.onChange44} min={-1} max={0} step={0.01} defaultValue={-1} />
                                        <txt style={{fontSize:22}}>{this.state.inputValue44}  </txt>
                                    </div>
                                    <Button type="primary" shape="round" size="large" style={{ marginLeft: 150, marginTop: 60, background: 'rgb(147, 197, 163)' }} onClick={this.onClick4}>Calculate</Button>
                                </div>
                        </div>
                        </div>

                        <div style={{width:"100%", height: 800, background: '#dcefef' }}>
                        <div>
                            {/*三变量模型显示 */}
                            <Content style={{ background: '#dcefef' }}>
                                <div className="txt" style={{height: 800, background: '#dcefef' }}>
                                {onShow}

                                </div>
                            </Content>
                        </div>


                        <div>
                            {/*四变量模型显示 */}
                            <Content style={{ background: '#dcefef' }}>
                                <div className="txt" style={{height: 800, background: '#dcefef' }}>
                                {onShow4}

                                </div>
                            </Content>
                        </div>
                        </div>


                        
                    </Layout>
                </Content>
            </div>
        )
    }
}
export default HccCalCalculation;